import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormProvider, useForm } from 'react-hook-form'

import { StyledDialog, FlexEndContainer, FlexDialogContent, FlexColumn, Form } from '../styles/Containers'
import Button, { SecondaryButton } from '../common/Button'
import BodyText, { BoldFormTitle } from '../styles/Text'
import { SelectMenuItem } from '../styles/TextField'
import FormSelect from '../inputFields/FormSelect'
import FormInput from '../inputFields/FormInput'
import { postCancelFOI } from '../../dataClient/apiCalls'
import { ErrorMessage } from '../common/UserMessage'
import { statusTypeMap } from '../../util/foiConsts'

function CloseFoiButton({ foiId, onSuccess = () => {} }) {
  const [isVisible, setIsVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const methods = useForm({
    defaultValues: {
      cancelType: 'WITHDRAWN',
      statusNote: ''
    }
  })
  const { handleSubmit, reset } = methods

  const handleOpen = () => setIsVisible(true)
  const closeDialog = () => {
    reset({ cancelType: 'WITHDRAWN', statusNote: '' })
    setIsVisible(false)
    setError(false)
    setIsLoading(false)
  }
  const handleClose = () => {
    if (isLoading) return
    closeDialog()
  }

  function onSubmit(data) {
    setIsLoading(true)
    setError(false)

    postCancelFOI(foiId, {
      cancelType: data.cancelType,
      statusNote: data.statusNote?.trim() || null
    })
      .then(() => {
        closeDialog()
        onSuccess()
      })
      .catch(e => {
        console.error('Failed closing FOI', e)
        setError(true)
        setIsLoading(false)
      })
  }

  return (
    <>
      <SecondaryButton aria-label="Close FOI" onClick={handleOpen}>
        Close FOI
      </SecondaryButton>
      <StyledDialog fullWidth open={isVisible} onClose={handleClose} keepMounted={false} maxwidth="560px">
        <FlexDialogContent>
          <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <FlexColumn gap="16px">
                <BoldFormTitle>Close FOI</BoldFormTitle>
                <BodyText>
                  This action will close the request - changing it to the selected status and moving it to your completed dashboard. Editing will be
                  disabled and any pending bills will be cancelled. You can reopen the request anytime to make changes.
                </BodyText>
                <FormSelect id="cancelType" label="Status" options={[]} defaultValue="WITHDRAWN">
                  <SelectMenuItem value="WITHDRAWN">{statusTypeMap.WITHDRAWN.label}</SelectMenuItem>
                  <SelectMenuItem value="ABANDONED">{statusTypeMap.ABANDONED.label}</SelectMenuItem>
                </FormSelect>
                <FormInput id="statusNote" label="Note" multiline minRows={1} />
                {error && <ErrorMessage>There was an error closing the request. Please try again.</ErrorMessage>}
                <FlexEndContainer>
                  <SecondaryButton type="button" onClick={handleClose} disabled={isLoading}>
                    Go Back
                  </SecondaryButton>
                  <Button type="submit" loading={isLoading}>
                    Confirm
                  </Button>
                </FlexEndContainer>
              </FlexColumn>
            </Form>
          </FormProvider>
        </FlexDialogContent>
      </StyledDialog>
    </>
  )
}

CloseFoiButton.propTypes = {
  foiId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func
}

export default CloseFoiButton
